<template>
    <div>
        <div>
            <table class="table table-bordered table-striped table-vcenter dataTable" ref="datatable" style="width: 100%;">
                <thead>
                    <tr>
                        <th v-if="!this.hide.includes('jobReference')">Job Reference</th>
                        <th v-if="!this.hide.includes('id')">#</th>
                        <th v-if="!this.hide.includes('position')">Position</th>
                        <th v-if="!this.hide.includes('collectionDate')">Collection Date</th>
                        <th v-if="!this.hide.includes('deliveryDate')">Delivery Date</th>
                        <th v-if="!this.hide.includes('collectionLocation')">Collection Location</th>
                        <th v-if="!this.hide.includes('deliveryLocation')">Delivery Location</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { buildColumns } from "@/helpers/build-columns";
import customerSelect from '@/components/movements/components/CustomerSelect.vue';

export default {
    components: {
        customerSelect,
    },

    props: {
        ajaxUrl: {
            type: String,
            required: true,
        },
        hide: {
            type: Array,
            default: () => [],
            required: false
        },
        orderBy: {
            type: Array | null,
            default: null,
        },
        old: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            default: () => [],
            required: false
        },
    },

    data () {
        return {
            columnDefinitions: {
                reference: {
                    data: 'job.reference',
                    orderable: false,
                    sortable: false,
                    width: '170px',
                    render: function (data, type, row) {
                        return row.computed_reference;
                    }
                },
                id: {
                    data: 'id',
                    orderable: false,
                    searchable: false,
                    width: '70px',
                    render: function (data, type, row) {
                        return row.computed_id;
                    }
                },
                position: {
                    data: 'position',
                },
                collectionDate: {
                    data: 'collection_date',
                    width: '200px',
                    render: function (data, type, row) {
                        return row.computed_collection_date;
                    }
                },
                deliveryDate: {
                    data: 'delivery_date',
                    width: '200px',
                    render: function (data, type, row) {
                        return row.computed_delivery_date;
                    }
                },
                collectionLocation: {
                    data: 'collection_location',
                },
                deliveryLocation: {
                    data: 'delivery_location',
                },
            },

            filters: {
                selectedCustomer: null,
            },

            selectedCustomer: null,
        }
    },

    mounted() {
        const table = window.jQuery(this.$refs.datatable).on('preXhr.dt', (e, settings, data) => {
            data.filters = this.filters;
        }).DataTable({
            processing: true,
            serverSide: true,
            pageLength: 25,
            lengthMenu: [25, 50, 100],
            ajax: {
                url: this.ajaxUrl,
            },
            order: this.orderBy ?? [[1, 'desc']],
            columns: buildColumns(this.columnDefinitions, this.hide),
        });

        // watch api to use table without saving it to data
        this.$watch(
            'filters',
            () => table.ajax.reload(null, false),
            {
                deep: true
            }
        );

        table.on('draw', function() {
            window.jQuery('#checkAll').on( 'click', function() {
                window.jQuery('.bulk-update-checkbox').each((_, el) => {
                    window.jQuery(el).click();
                    el.checked = this.checked;
                });
            });
        });
    },

    methods: {
        updateSelectedCustomer(value) {
            if (value !== null) {
                this.selectedCustomer = value;
                this.filters.selectedCustomer = value;
            } else {
                this.selectedCustomer = null;
                this.filters.selectedCustomer = null;
            }
        },
    },
};
</script>
